module.exports = __webpack_public_path__ + "img/weddings_22_V.b53cf0c8.webp";